import type { CertificationType } from 'src/common/enums/certification';
import type { PaymentPendingType } from 'src/features/payment-pending/payment-pending.constants';

export enum CheckoutType {
  SUBSCRIPTION = 'SUBSCRIPTION',
  BUSINESS_SUBSCRIPTION = 'BUSINESS_SUBSCRIPTION',
  CLOUD_ADDON = 'CLOUD_ADDON',
  BUSINESS_CHECKOUT = 'BUSINESS_CHECKOUT',
  CERTIFICATION_EXAM = 'CERTIFICATION_EXAM',
}

export type PersonalSubscriptionPayload = {
  planId: string;
  campaign?: string;
};

export type BusinessSubscriptionPayload = {
  companyId: string;
};

export type BusinessCheckoutPayload = {
  planId: string;
  forCompany?: boolean;
  meta: {
    companyId?: string;
    companyDomain: string;
    firstName: string;
    lastName: string;
    email: string;
    companyName: string;
    jobTitle: string;
    vatNo?: string;
    address: string;
    city: string;
    country: string;
    zip: string;
    licences: number;
  };
};

export type CertificationExamCheckoutPayload = {
  certificationExamType: CertificationType;
  itemPriceId: string;
};

export type GenerateCheckoutPayload =
  | PersonalSubscriptionPayload
  | BusinessSubscriptionPayload
  | BusinessCheckoutPayload
  | CertificationExamCheckoutPayload;

export interface GenerateCheckoutUrlMutationArg {
  path: string;
  payload?: GenerateCheckoutPayload;
}

export interface Config {
  path: string;
  pendingType: PaymentPendingType;
}
